var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagQuoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5202 1.75747C27.4692 1.75747 28.2308 2.5249 28.2367 3.47393V17.8032C28.2367 18.7522 27.4692 19.5138 26.5202 19.5138H18.307L17.7914 20.0293L15.0381 22.7826C15.0146 22.8061 14.9795 22.8061 14.9561 22.7826L12.2027 20.0293L11.6872 19.5138H3.47393C2.5249 19.5138 1.76333 18.7463 1.75747 17.8032V3.47393C1.75747 2.5249 2.5249 1.76333 3.47393 1.75747H26.5202ZM26.5202 0H3.47393C1.55243 0 0 1.55829 0 3.47393V17.8032C0 19.7188 1.55243 21.2712 3.47393 21.2712H10.9666L13.72 24.0246C14.4288 24.7334 15.577 24.7334 16.2859 24.0246L19.0393 21.2712H26.5261C28.4417 21.2712 30 19.7188 30 17.8032V3.47393C29.9941 1.55829 28.4417 0 26.5202 0Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.997 13.099C14.0714 13.099 13.3099 12.3668 13.2747 11.4412L13.0462 5.69423C13.0111 4.73934 13.7492 3.93676 14.7041 3.90161H14.7744H15.2314C16.1863 3.90161 16.9595 4.6749 16.9595 5.62979V5.70009L16.7311 11.447C16.6842 12.3668 15.9226 13.099 14.997 13.099Z",
    fill: "#8F8F8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.997 13.9191C15.9519 13.9191 16.7193 14.6924 16.7193 15.6414C16.7193 16.5963 15.946 17.3638 14.997 17.3638C14.0421 17.3638 13.2747 16.5905 13.2747 15.6414C13.2747 14.6924 14.0421 13.9191 14.997 13.9191Z",
    fill: "#8F8F8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagQuoteIcon);
export default __webpack_public_path__ + "static/media/flagQuoteIcon.dd22995a3ffa769f9cb8e1ce8e62c2c8.svg";
export { ForwardRef as ReactComponent };